import { render, staticRenderFns } from "./UserViewCourseProgress.vue?vue&type=template&id=9965e098&"
import script from "./UserViewCourseProgress.vue?vue&type=script&lang=js&"
export * from "./UserViewCourseProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports